import { GameBlocks, GameBlocksRaw } from '@/types';
import { getRandomVibrantColor } from '@/helpers/colorHelper';

export const gameBlocksAdapter = (gameBlocks: GameBlocksRaw[]): GameBlocks[] => {
    return gameBlocks.map((gameBlock) => {
        const color = getRandomVibrantColor();

        return {
            ...gameBlock,
            icon: toGetIcon(gameBlock),
            path: `/section/game-block/${gameBlock.string_id}`,
            loading: false,
            isHaveGames: false,
            color
        };
    });
};

function toGetIcon(gameBlock: GameBlocksRaw) {
    switch (gameBlock.string_id) {
        case 'slot_games':
            return 'asterisk';
        case 'new_games':
            return 'sparkles';
        case 'all_games':
            return 'bolt';
        case 'top_games':
            return 'crown';
        case 'roulette_games':
            return 'box';
        default:
            console.warn(`Unknown game block type: ${gameBlock.string_id}`);
            return 'default_icon';
    }
}
